/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const starFilled = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M10 1l3 6 6 .75-4.12 4.62L16 19l-6-3-6 3 1.13-6.63L1 7.75 7 7z" />
	</SVG>
);

export default starFilled;
